import { ReactNode, useContext, useEffect } from 'react';

import Context from '../../Context';

interface ContentProps {
  children: ReactNode;
}

export const Content = ({ children }: ContentProps) => {
  const { setContent } = useContext(Context);

  setContent(children);

  useEffect(() => {
    return () => {
      setContent(null);
    };
  }, [setContent]);

  return null;
};
